<template>
  <div class="animated revealUp po_wrapper" style="zoom: 0.88;">
    <div class="section-title mb-3">
      {{ $t("add") }} {{ $t("purchase") }} {{ $t("order") }}
    </div>
    <section class="white-wrapper">
      <form class="row">
        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedCinema"
                label="cine_name"
                track-by="cine_id"
                :placeholder="$t('Cinema')"
                :options="Cinemas"
                @select="onSelectCinema($event)"
                @remove="onSelectCinema($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedCinema.length == 0"
              >Please Select Cinema.</span
            >
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="selectedVendor"
                label="v_name"
                track-by="v_id"
                :placeholder="$t('Vendor')"
                :options="Vendors"
                @select="onSelectVendor($event)"
                @remove="onSelectVendor($event, 'remove')"
              >
                <span slot="noResult">Oops! No Results found.</span>
              </multiselect>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_selectVendor')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && selectedVendor.length == 0"
              >Please Select Vendor.</span
            >
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="purchasOrderDetails.po_date"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="purchasOrderDetails.po_date"
                  name="purchasedate"
                  id="purchasedate"
                  v-validate="'required'"
                  typeable
                ></Datepicker>
                <label
                  :class="
                    purchasOrderDetails.po_date &&
                    typeof purchasOrderDetails.po_date === 'object'
                      ? 'active'
                      : ''
                  "
                  >{{ $t("purchaseorderdate") }}</label
                >
              </div>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_PurchaseOrderDate')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('purchasedate')">{{
              errors.first("purchasedate")
            }}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="purchasOrderDetails.remarks"
              />
              <label>{{ $tc("remarks") }} (optional)</label>
            </div>
            <!-- <Tooltip :title="$t('purchaseOrder_TotalAmount')" /> -->
          </div>
          <p class="error_message">
            <span v-if="purchasOrderDetails.remarks && purchasOrderDetails.remarks.length > 200">{{"Remark cannot be more than 200 characters."}}</span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("purchaseorderlock") }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="purchasOrderDetails.po_lock"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-4 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ "Show All Raw Materials" }}</label>
            <!-- <label class="ios-switch ml-2"> -->
            <b-form-checkbox
              v-model="showAll"
              type="checkbox"
              class="j-checkbox"
              checked
            />
            <!-- <span class="switch-slider"></span> -->
            <!-- </label> -->
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div
          class="w-100"
          v-if="purchasOrderDetails.cinema_id && purchasOrderDetails.v_id"
        >
          <b-collapse
            v-model="collapseObj.itemsArray"
            class="pt-3 px-2 bor mb-4 back collapse show w-100 purchase_table"
          >
            <section class="row">
              <div class="w-100 mx-3 mb-3">
                <span
                  class="redLine"
                  v-if="
                    purchaseOrderErrorDetails['hasError'] &&
                    purchaseOrderErrorDetails['errorMsg']
                  "
                  >{{ purchaseOrderErrorDetails["errorMsg"] }}</span
                >
                <table
                  class="swc-report-table po_table"
                  border="1"
                  style="table-layout: auto; background: white"
                >
                  <thead class="tableHeaderSticky">
                    <tr>
                      <th class="bg-lightgrey p-1" style="width: 320px">
                        Item
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 150px">QTY</th>
                      <th class="bg-lightgrey p-1" style="width: 150px">
                        Unit
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 150px">
                        Remarks
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 150px">
                        Tax %
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 125px">
                        Net Rate
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 160px">
                        Net Total
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 125px">Tax</th>
                      <th class="bg-lightgrey p-1" style="width: 160px">
                        Gross Total
                      </th>
                      <th class="bg-lightgrey p-1" style="width: 80px">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="RawMaterialsList.length > 0">
                    <tr
                      v-for="(item, vendorIndex) in RawMaterialsList"
                      :key="`${vendorIndex}${vendorIndex}`"
                      :class="
                        errIndex == vendorIndex
                          ? 'errRow'
                          : purchaseOrderErrorDetails['hasError'] &&
                            purchaseOrderErrorDetails[
                              'errorIndexArray'
                            ].includes(vendorIndex)
                          ? 'errorLine'
                          : !isNaN(String(item['poi_rate'])) &&
                            item['rm_id'] &&
                            item['poi_rate'] <= 0
                          ? 'redLine'
                          : ''
                      "
                    >
                      <td class="text-left p-0 po_item">
                        <multiselect
                          :key="`___${vendorIndex}${vendorIndex}`"
                          :class="`___${vendorIndex}${vendorIndex}`"
                          :options="
                            showAll
                              ? rawMaterialsNew
                              : filterRW(rawMaterialsNew)
                          "
                          v-model="item.main_raw_material"
                          :searchable="true"
                          label="rm_name"
                          track-by="rm_id"
                          placeholder=" Raw Material"
                          @select="
                            onSelectNewRawMaterial($event, vendorIndex, 0)
                          "
                          @remove="
                            onSelectNewRawMaterial(
                              $event,
                              vendorIndex,
                              0,
                              'remove'
                            )
                          "
                          :showLabels="false"
                        ></multiselect>
                      </td>
                      <td class="text-center p-0">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_qty"
                            min="0"
                            max="9999999"
                            maxlength="7"
                            :name="`item_qty_${vendorIndex}`"
                            :id="`item_qty_${vendorIndex}`"
                            type="number"
                            class="qtyInput purchase_input"
                            @input="cinemaChargesCalculation(vendorIndex)"
                            placeholder="Qty"
                          />
                        </div>
                      </td>
                      <td class="text-left p-0 po_item">
                        <multiselect
                          :options="item.uom_units"
                          v-model="item.selectedUOM"
                          :searchable="true"
                          label="uom_short_form"
                          track-by="uom_id"
                          placeholder="UOM"
                          :showLabels="false"
                          :allowEmpty="false"
                          @select="onSelectUom($event, vendorIndex)"
                        />
                      </td>
                      <td class="text-left p-0 po_item">
                        <textarea
                          style="border-radius: 5px"
                          class="w-100 form-control form-control-sm"
                          placeholder
                          type="text"
                          v-model="item.poi_remarks"
                          rows="1"
                        ></textarea>
                      </td>
                      <!-- <td class="text-center p-0 po_item">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_tax_in_percentage"
                            min="0"
                            max="9999"
                            maxlength="3"
                            type="number"
                            name="taxamount"
                            id="taxamount"
                            @input="calculateNetAmount(item, vendorIndex)"
                            placeholder="."
                            class="w-50 qtyInput purchase_input"
                          />
                          <span class="percentText">%</span>
                        </div>
                      </td> -->
                      <td class="text-right p-0 manual_bill_item">
                        <multiselect
                          :options="ChargeSettings"
                          v-model="item.selectedChargeSetting"
                          :searchable="true"
                          label="pas_charge_setting_name"
                          track-by="pas_id"
                          placeholder="Tax"
                          :showLabels="false"
                          @select="onSelectBillTaxSetting($event, vendorIndex)"
                        />
                      </td>
                      <td class="text-center p-0">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_rate"
                            min="0"
                            max="9999999"
                            step="0.00001"
                            type="number"
                            @input="cinemaChargesCalculation(vendorIndex)"
                            @blur="item.poi_rate = parseFloat(item.poi_rate || 0).toFixed(5)"
                            placeholder="Rate"
                            class="qtyInput purchase_input"
                          />
                        </div>
                      </td>
                      <td class="text-right">
                        {{ currFormat5(parseFloat(item.poi_price)) }}
                      </td>
                      <td class="text-center p-0">
                        <div class="input_text-center">
                          <input
                            v-model="item.poi_tax_amount"
                            min="0"
                            max="9999999"
                            maxlength="7"
                            type="number"
                            @input="manuallyChangeTax(vendorIndex)"
                            placeholder="Tax Amt."
                            class="qtyInput purchase_input"
                          />
                        </div>
                      </td>
                      <!-- <td class="text-right">
                        {{ currFormat5(item.poi_tax_amount) }}
                      </td> -->
                      <td class="text-right">
                        {{ currFormat5(parseFloat(item.poi_total_amount)) }}
                      </td>
                      <td>
                        <div
                          class="icon-sm-minus blue-icon ml-2 btn"
                          @click.prevent.stop="removeVendor(vendorIndex)"
                        ></div>
                      </td>
                    </tr>
                    <tr class="">
                      <td colspan="11">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="addVendor()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="RawMaterialsList.length > 0">
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="2" class="font-weight-bold text-left">
                        Net Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{
                          currFormat5(
                            RawMaterialsList.reduce(
                              (acc, { poi_price }) =>
                                acc + parseFloat(poi_price || 0),
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="2" class="font-weight-bold text-left">
                        Tax Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{
                          currFormat5(
                            RawMaterialsList.reduce(
                              (acc, { poi_tax_amount }) =>
                                acc + parseFloat(poi_tax_amount || 0),
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6" class="borderNone"></td>
                      <td colspan="2" class="font-weight-bold text-left">
                        Gross Total
                      </td>
                      <td colspan="2" class="font-weight-bold text-right">
                        {{
                          currFormat5(
                            RawMaterialsList.reduce(
                              (acc, { poi_total_amount }) =>
                                acc + parseFloat(poi_total_amount || 0),
                              0
                            )
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr class="">
                      <td colspan="10"></td>
                    </tr>
                    <tr class="">
                      <td colspan="10">
                        <div
                          class="row d-flex align-items-center justify-content-center border-top mt-4 mb-3 position-relative"
                        >
                          <button
                            @click.prevent.stop="addVendor()"
                            class="btn-transparent add-more-button addBtn_multi"
                          >
                            <img
                              src="@/assets/img/icons/plus.svg"
                              height="24"
                              width="24"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </b-collapse>
        </div>

        <div class="col-md-12 mb-4 text-center">
          <button
            :disabled="btenable"
            v-if="purchasOrderDetails.cinema_id && purchasOrderDetails.v_id"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("save") }}</button
          >&nbsp;
          <router-link
            to="purchase-order"
            class="btn btn-default btn-outline-grey"
            >{{ $t("cancel") }}</router-link
          >
        </div>
      </form>
    </section>
  </div>
</template>

<script>
  import MasterService from "@/services/MasterService";
  import PosFnbService from "@/services/PosFnbService";
  import CinemasService from "@/services/CinemasService";
  import { CLIENT_NAME } from "@/helper/Role";

  export default {
    data() {
      return {
        ChargeSettings: [],
        purchaseOrderErrorDetails: {
          errorMsg: "",
          hasError: false,
          errorIndexArray: [],
        },
        showAll: false,
        errIndex: null,
        collapseObj: {
          itemsArray: true,
          item_array: true,
        },
        btenable: false,
        isRoleID: true,
        submitted: false,
        purchasOrderDetails: {
          cinema_id: "",
          v_id: "",
          po_date: new Date(),
          po_total_amount: "",
          po_lock: false,
          po_is_active: true,
          remarks: "",
        },
        searchRawMaterial: "",
        searchVendor: "",
        searchCinema: "",
        RawMaterialsList: [
          {
            main_raw_material: "",
            rm_name: "",
            rm_id: "",
            po_quantity: "",
            poi_qty: "",
            poi_rate: "",
            poi_tax_in_percentage: this.defaultTaxPercent || "",
            poi_tax_amount: "",
            uom_unit: "",
            uom_id: "",
            po_total_amount: "",
            SelectedRawMaterial: null,
            uom_units: [],
            firstTimeSet: 0,
            isNew: false,
            showAll: false,
            selectedUOM: null,
            poi_remarks: "",
            charge_setting_id: null,
            charge_setting_name: null,
            selectedChargeSetting: "",
            taxes: [],
            charge_array: [],
          },
        ],
        Cinemas: [],
        CinemasCopy: [],
        RawMaterials: [],
        RawMaterialsCopy: [],
        Vendors: [],
        VendorsCopy: [],
        measurements: [],
        selectedCinema: "",
        selectedVendor: "",
        selectedQuantity: "",
        selectedUom: "",
        listOfConversionRate: [],
        cinema_selected_new: [],
        rawMaterialsNew: [],
        selectedRawMaterialPrice: [],
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      this.getCinemasList(obj);
      this.getRawMaterialsListMain();
    },
    mounted() {
      this.getVendorsList();
      console.log("BUILD check");
      this.RawMaterialsList = Array.from({ length: 10 }, () => ({
        main_raw_material: "",
        rm_name: "",
        rm_id: "",
        po_quantity: "",
        poi_qty: "",
        poi_rate: "",
        poi_tax_in_percentage: this.defaultTaxPercent || "",
        poi_tax_amount: "",
        uom_unit: "",
        uom_id: "",
        po_total_amount: "",
        SelectedRawMaterial: null,
        uom_units: [],
        firstTimeSet: 0,
        isNew: false,
        showAll: false,
        selectedUOM: null,
        poi_remarks: "",
        charge_setting_id: null,
        charge_setting_name: null,
        selectedChargeSetting: "",
        taxes: [],
        charge_array: [],
      }));

      // this.getRawMaterials();
      // this.getunitsofmeasurements();
    },
    computed: {
      defaultTaxPercent() {
        let taxPercent = "";
        if (CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME) {
          taxPercent = 10;
        }
        return taxPercent;
      },
      isEpix() {
        return CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME;
      },
    },
  methods: {
  manuallyChangeTax: function (listIndex) {
    let qty = this.getFloat(this.RawMaterialsList[listIndex].poi_qty) || 1;

    // Base net rate (poi_rate) stays fixed
    let A = this.getFloat(this.RawMaterialsList[listIndex].poi_rate || 0);

    // Manually entered total tax
    let manualTotalTax = this.getFloat(
      this.RawMaterialsList[listIndex].poi_tax_amount || 0
    );

    // Unit net = poi_rate (base ticket rate)
    let unitNet = A;

    // poi_price = total NET (unit net × qty)
    this.RawMaterialsList[listIndex].poi_price = parseFloat(
      unitNet * qty
    ).toFixed(5);

    // poi_total_amount = total GROSS = (unit net × qty) + manual total tax
    this.RawMaterialsList[listIndex].poi_total_amount = parseFloat(
      unitNet * qty + manualTotalTax
    ).toFixed(this.MIN_FRACTION_DIGITS);

    // Recalculate PO total
    this.purchasOrderDetails.po_total_amount = 0;
    this.RawMaterialsList.map((x) => {
      if (x.poi_total_amount) {
        this.purchasOrderDetails.po_total_amount += parseFloat(x.poi_total_amount);
      }
    });

    console.log({
      TicketRate: A,
      qty,
      manualTotalTax,
      poi_price: this.RawMaterialsList[listIndex].poi_price,
      poi_total_amount: this.RawMaterialsList[listIndex].poi_total_amount,
    });
  },
      filterRW(rm) {
        let filtered = rm.filter((rm) => {
          if (!this.purchasOrderDetails.v_id) return true;

          let v_ids = (rm.vendor_ids || "")
            .split(",")
            .map((x) => String(x).trim())
            .map((x) => parseInt(x));

          if (!rm.vendor_ids) return false;
          return v_ids.includes(parseInt(this.purchasOrderDetails.v_id));
        });

        // console.log({
        //   "rm.length": rm.length,
        //   "filtered.length": filtered.length
        // });
        // console.log({
        //   filtered
        // });

        return filtered;
      },
      onSelectBillTaxSetting(taxSetting, listIndex) {
        this.RawMaterialsList[listIndex].charge_setting_name =
          taxSetting.pas_charge_setting_name;
        this.RawMaterialsList[listIndex].charge_setting_id = taxSetting.pas_id;
        this.getCinemaCharges(taxSetting, listIndex);
      },
      getChargeSettingName: function (cinema_id) {
        this.ChargeSettings = [];
        CinemasService.GetChargeSettingsWithChargeTypes({ cinema_id: cinema_id })
          .then(async (response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.ChargeSettings = data.Records;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Error :", error);
          });
      },
      getCinemaCharges: function (charge_setting, index = 0) {
        this.RawMaterialsList[index].charge_array = [];
        this.RawMaterialsList[index].taxes = [];

        let cinemaChargesArray = charge_setting["charge_array"] || [];
        this.RawMaterialsList[index].charge_array =
          charge_setting["charge_array"] || [];

        cinemaChargesArray.map((x) => {
          let obj = {
            pas_order: x.pas_order || 0,
            charge_name: x.ct_name,
            cinemacharges: 0,
            charge_value: x.pas_charge_value,
            ct_id: x.ct_id,
            ct_code: x.ct_code,
            pas_id: x.pas_id,
            pas_is_percentage: x.pas_is_percentage,
          };
          this.RawMaterialsList[index].taxes.push(obj);
        });

        this.cinemaChargesCalculation(index);
      },
      getFloat(val = "0", fractionDigits = 8) {
        let parsed = parseFloat(String(val) || "0") || parseFloat("0");
        return parseFloat(parsed.toFixed(fractionDigits));
      },
      cinemaChargesCalculation: function (listIndex) {
        let tempChargeArray = this.RawMaterialsList[listIndex].charge_array;
        if (true) {
          let grosss = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "Y")
            .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
            .filter((g) => g.pas_is_percentage === "Y");

          let nets = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "N")
            .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
            .filter((g) => g.pas_is_percentage === "Y");

          let misc_products = this.getSafe(
            () => tempChargeArray.map((x) => x),
            []
          )
            .filter((g) => g.pas_is_percentage === "N")
            .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

          console.log({
            nets,
            grosss,
            misc_products,
            taxes: tempChargeArray.map((x) => x),
          });

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
          let vat_percent = this.getFloat(
            this.getSafe(() => grosss[0].pas_charge_value, 0)
          );

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
          let net_1_percent = this.getFloat(
            this.getSafe(() => nets[0].pas_charge_value, "0")
          );

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
          let net_2_percent = this.getFloat(
            this.getSafe(() => nets[1].pas_charge_value, "0")
          );

          let misc_product_rate_pas_id = this.getSafe(
            () => misc_products[0].pas_id
          );
          let misc_product_rate_1 = this.getFloat(
            this.getSafe(() => misc_products[0].pas_charge_value, "0")
          );
          let misc_rate_exist =
            misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;

          // poi_rate is now treated as UNIT NET RATE (exclusive/base price, tax excluded)
          let amount = this.getFloat(
            this.RawMaterialsList[listIndex].poi_rate || 0
          );

          /** Ticket Rate (Base) - poi_rate itself is the net base ticket rate */
          let A = amount;
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A);
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A);
          /** 3D/Prod - fixed misc charge (already exclusive, no back-calculation needed) */
          let B = misc_product_rate_1;
          /** Taxable/Net = base ticket + net charges + misc */
          let E = this.getFloat(A + C + D + B);
          /** VAT - applied on net/taxable amount */
          let F = this.getFloat((vat_percent / 100) * E);
          /** Gross = Net + VAT */
          let G = this.getFloat(E + F);

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            misc_rate_exist,
            misc_product_rate_1,
          });
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            "3D": B,
            TicketRate: A,
            ProductRate: B,
          });

          let NET_AMT = E;
          let BASE_RATE = A;
          let NET_1_AMT = C;
          let NET_2_AMT = D;
          let NET_3_AMT = B;
          let VAT_AMT = F;
          let Gross = G;

          // Unit net = base ticket rate + misc (3D/prod), excluding percentage-based taxes
          let temp_unit_rate = parseFloat(BASE_RATE + NET_3_AMT);

          tempChargeArray.map((x, i) => {
            let index = this.RawMaterialsList[listIndex]["taxes"].findIndex(
              (zz) => zz.ct_id == x.charge_type_id
            );

            if (x.pas_id == net_1_pas_id) {
              x.cinemacharges = NET_1_AMT;
            }
            if (x.pas_id == net_2_pas_id) {
              x.cinemacharges = NET_2_AMT;
            }
            if (x.pas_id == misc_product_rate_pas_id) {
              x.cinemacharges = NET_3_AMT;
            }
            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = VAT_AMT;
            }

            this.RawMaterialsList[listIndex].taxes[index].cinemacharges =
              x.cinemacharges || 0;
          });

          let unitNet = parseFloat(temp_unit_rate);
          let unitGross = parseFloat(Gross); // Gross is now computed, not taken from poi_rate

          let qty = this.getFloat(this.RawMaterialsList[listIndex].poi_qty);

          // poi_price = total NET amount (unit net × qty)
          this.RawMaterialsList[listIndex].poi_price = parseFloat(
            parseFloat(unitNet || 0) * Number(qty || 0)
          ).toFixed(5);

          // poi_total_amount = total GROSS amount (computed gross × qty)
          this.RawMaterialsList[listIndex].poi_total_amount = parseFloat(
            unitGross * qty
          ).toFixed(this.MIN_FRACTION_DIGITS);

          this.RawMaterialsList[listIndex].taxes.forEach((tax) => {
            tax["cinemacharges"] = +parseFloat(
              parseFloat(tax["cinemacharges"]) * Number(qty || 0)
            ).toFixed(this.MIN_FRACTION_DIGITS);
          });

          this.RawMaterialsList[listIndex].poi_tax_amount = parseFloat(
            this.RawMaterialsList[listIndex].taxes.reduce(
              (acc, { cinemacharges }) =>
                acc +
                +parseFloat(cinemacharges || 0).toFixed(this.MIN_FRACTION_DIGITS),
              0
            )
          ).toFixed(this.MIN_FRACTION_DIGITS);

          this.purchasOrderDetails.po_total_amount = 0;
          this.RawMaterialsList.map((x) => {
            if (x.poi_total_amount) {
              this.purchasOrderDetails.po_total_amount += parseFloat(
                x.poi_total_amount
              );
            }
          });

          console.log("this.RawMaterialsList[listIndex]:", this.RawMaterialsList[listIndex]);
        }
      },
      cinemaChargesCalculationGross: function (listIndex) {
        let tempChargeArray = this.RawMaterialsList[listIndex].charge_array;
        if (true) {
          let grosss = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "Y")
            .filter((g) => String(g.ct_name).toUpperCase().includes("VAT"))
            .filter((g) => g.pas_is_percentage === "Y");

          let nets = this.getSafe(() => tempChargeArray.map((x) => x), [])
            .filter((z) => z.pas_is_on_gross_amount == "N")
            .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"))
            .filter((g) => g.pas_is_percentage === "Y");

          let misc_products = this.getSafe(
            () => tempChargeArray.map((x) => x),
            []
          )
            .filter((g) => g.pas_is_percentage === "N")
            .filter((g) => !String(g.ct_name).toUpperCase().includes("VAT"));

          console.log({
            nets,
            grosss,
            misc_products,
            taxes: tempChargeArray.map((x) => x),
          });

          let vat_pas_id = this.getSafe(() => grosss[0].pas_id);
          let vat_percent = this.getFloat(
            this.getSafe(() => grosss[0].pas_charge_value, 0)
          );

          let net_1_pas_id = this.getSafe(() => nets[0].pas_id);
          let net_1_percent = this.getFloat(
            this.getSafe(() => nets[0].pas_charge_value, "0")
          );

          let net_2_pas_id = this.getSafe(() => nets[1].pas_id);
          let net_2_percent = this.getFloat(
            this.getSafe(() => nets[1].pas_charge_value, "0")
          );

          let misc_product_rate_pas_id = this.getSafe(
            () => misc_products[0].pas_id
          );
          let misc_product_rate_1 = this.getFloat(
            this.getSafe(() => misc_products[0].pas_charge_value, "0")
          );
          let misc_rate_exist =
            misc_product_rate_1 > 0 && misc_product_rate_pas_id > 0;

          let amount = this.getFloat(
            this.RawMaterialsList[listIndex].poi_rate || 0
          );

          /** Gross */
          let G = amount;
          /** Taxable/Net */
          let E = this.getFloat(amount / (1 + vat_percent / 100));
          /** VAT */
          let F = this.getFloat((vat_percent / 100) * E);
          /** 3D/Prod */
          let B = this.getFloat(misc_product_rate_1 / (1 + vat_percent / 100));
          /** Ticket Rate */
          let totalPerCentOfA = 1 + (net_1_percent + net_2_percent) / 100;
          let A = this.getFloat((E - B) / totalPerCentOfA);
          /** Film Dev Tax */
          let C = this.getFloat((net_1_percent / 100) * A);
          /** State & Local Ent Tax */
          let D = this.getFloat((net_2_percent / 100) * A);

          console.log({
            amount,
            vat_percent,
            net_1_percent,
            net_2_percent,
            totalPerCentOfA,
            misc_rate_exist,
            misc_product_rate_1,
          });
          console.log({
            Gross: G,
            Net: E,
            VAT: F,
            FDT: C,
            SLE: D,
            "3D": B,
            TicketRate: A,
            ProductRate: B,
          });

          let NET_AMT = E;
          let BASE_RATE = A;
          let NET_1_AMT = C;
          let NET_2_AMT = D;
          let NET_3_AMT = B; // misc_product_rate_1
          let VAT_AMT = F;
          let Gross = G;

          let temp_unit_rate = parseFloat(
            BASE_RATE + NET_3_AMT
          );

          tempChargeArray.map((x, i) => {
            let index = this.RawMaterialsList[listIndex]["taxes"].findIndex(
              (zz) => zz.ct_id == x.charge_type_id
            );

            if (x.pas_id == net_1_pas_id) {
              x.cinemacharges = NET_1_AMT;
            }
            if (x.pas_id == net_2_pas_id) {
              x.cinemacharges = NET_2_AMT;
            }
            if (x.pas_id == misc_product_rate_pas_id) {
              x.cinemacharges = NET_3_AMT;
            }

            if (x.pas_id == vat_pas_id) {
              x.cinemacharges = VAT_AMT;
            }

            this.RawMaterialsList[listIndex].taxes[index].cinemacharges =
              x.cinemacharges || 0;
          });

          let unitNet = parseFloat(temp_unit_rate);

          let unitGross = parseFloat(
            this.RawMaterialsList[listIndex].poi_rate || 0
          );

          let qty = this.getFloat(this.RawMaterialsList[listIndex].poi_qty);

          this.RawMaterialsList[listIndex].poi_price = parseFloat(
            parseFloat(unitNet || 0) * Number(qty || 0)
          ).toFixed(5);

          this.RawMaterialsList[listIndex].poi_total_amount = parseFloat(
            unitGross * qty
          ).toFixed(this.MIN_FRACTION_DIGITS);

          this.RawMaterialsList[listIndex].taxes.forEach((tax) => {
            tax["cinemacharges"] = +parseFloat(
              parseFloat(tax["cinemacharges"]) * Number(qty)
            ).toFixed(this.MIN_FRACTION_DIGITS);
          });

          this.RawMaterialsList[listIndex].poi_tax_amount = parseFloat(
            this.RawMaterialsList[listIndex].taxes.reduce(
              (acc, { cinemacharges }) =>
                acc +
                +parseFloat(cinemacharges || 0).toFixed(this.MIN_FRACTION_DIGITS),
              0
            )
          ).toFixed(this.MIN_FRACTION_DIGITS);

          this.purchasOrderDetails.po_total_amount = 0;
          this.RawMaterialsList.map((x) => {
            if (x.poi_total_amount) {
              this.purchasOrderDetails.po_total_amount += parseFloat(
                x.poi_total_amount
              );
            }
          });


          console.log("this.RawMaterialsList[listIndex]:", this.RawMaterialsList[listIndex]);
        }
      },
      onSelectNewRawMaterial(event, vendorIndex, rawKey, type) {
        console.log(event, vendorIndex, rawKey, "Rawww");
        if (type == "remove") {
          this.RawMaterialsList[vendorIndex]["main_raw_material"] = "";
          this.RawMaterialsList[vendorIndex].rm_name = "";
          this.RawMaterialsList[vendorIndex].rm_id = null;
          this.RawMaterialsList[vendorIndex].SelectedRawMaterial = "";
          this.RawMaterialsList[vendorIndex].uom_unit = "";
          this.RawMaterialsList[vendorIndex].uom_id = "";
          this.RawMaterialsList[vendorIndex].poi_qty = "";
          this.RawMaterialsList[vendorIndex].poi_rate = "";
          this.RawMaterialsList[vendorIndex].poi_tax_in_percentage = "";
        } else {
          let findIndexNew = this.RawMaterialsList.findIndex((x) => {
            return x.rm_id == String(event.rm_id);
          });
          console.log("findIndexNew", findIndexNew);
          // if (findIndexNew >= 0) {
          //   this.$toasted.show(` ${event.rm_name} already selected `);
          //   this.RawMaterialsList[vendorIndex]["main_raw_material"] = "";
          //   return false;
          // }
          let checkIndex = this.RawMaterials.findIndex((x) => {
            return x.rm_id == event.rm_id;
          });
          console.log(this.RawMaterials, checkIndex, "checkIndex");
          if (checkIndex >= 0) {
            console.log("COMING HERE uuiui");
            this.onSelectRawMaterial(
              this.RawMaterials[checkIndex],
              vendorIndex,
              rawKey
            );
          } else {
            console.log("COMING HERE ehejfh");
            this.RawMaterialsList[vendorIndex]["rm_id"] = event.rm_id;
            this.RawMaterialsList[vendorIndex]["rm_name"] = event.rm_name;
            this.RawMaterialsList[vendorIndex]["rm_name"] = event.rm_name;
            this.RawMaterialsList[vendorIndex]["selectedUOM"] = {
              uom_id: event.uom_id,
              uom_short_form: event.uom_short_form,
              uom_unit: event.uom_unit,
            };
            this.RawMaterialsList[vendorIndex]["isNew"] = true;
            console.log("Raw Material Not Found In Vendor");
            this.getRelatedUom(vendorIndex, event.rm_id);
            console.log(this.RawMaterialsList);
            //EXTEND
            this.RawMaterialsList[vendorIndex]["poi_tax_amount"] = "";
            this.RawMaterialsList[vendorIndex]["poi_tax_in_percentage"] =
              this.defaultTaxPercent || "";
            this.RawMaterialsList[vendorIndex]["poi_total_amount"] = "";
            this.RawMaterialsList[vendorIndex]["po_quantity"] = "";
            this.RawMaterialsList[vendorIndex]["poi_qty"] = "";
            this.RawMaterialsList[vendorIndex]["poi_rate"] = "";
            this.RawMaterialsList[vendorIndex]["poi_price"] = "";
            this.RawMaterialsList[vendorIndex]["uom_units"] = [];
            this.RawMaterialsList[vendorIndex]["uom_id"] = event.uom_id;
            this.RawMaterialsList[vendorIndex]["uom_unit"] = event.uom_unit;
          }

          console.log("EVENT check", event);
        }
      },
      getRawMaterialsListMain: function () {
        this.rawMaterialsNew = [];
        let payload = {
          limit: 10000,
          currentPage: 1,
          searchKey: "rm_name",
          searchValue: "",
          columnName: "rm_name",
          orderBy: "asc",
          filter_is_active: "Y",
        };
        PosFnbService.GetRawMaterialsList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.rawMaterialsNew = data.Records;
              console.log(this.rawMaterialsNew);
            } else {
              this.$toasted.show("No Records Found");
            }
          })
          .catch(this._CatchError); //message
      },
      onSearchRawMaterial: function (value) {
        if (this.searchRawMaterial && this.searchRawMaterial.length > 0) {
          this.RawMaterials = this.RawMaterialsCopy.filter((x) => {
            if (
              x.rm_name
                .toLowerCase()
                .includes(this.searchRawMaterial.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.RawMaterials = this.RawMaterialsCopy;
        }
      },
      onSearchCinema: function (value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.Cinemas = this.CinemasCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Cinemas = this.CinemasCopy;
        }
      },
      onSearchVendor: function (value) {
        if (this.searchVendor && this.searchVendor.length > 0) {
          this.Vendors = this.VendorsCopy.filter((x) => {
            if (
              x.v_name.toLowerCase().includes(this.searchVendor.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.Vendors = this.VendorsCopy;
        }
      },
      clearSelectedDate: function () {
        this.purchasOrderDetails.po_date = "";
      },
      getCinemasList: function (cine_id) {
        // let payload = {
        //   tableName: "ms_cinemas",
        //   cine_is_active: "Y"
        // };
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
              this.CinemasCopy = data.Records;
              this.Cinemas.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  // this.selectedCinema = x.cine_name;
                  this.onSelectCinema({
                    cine_id: x.cine_id,
                    cine_name: x.cine_name,
                  });
                }
              });
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getVendorsList: function () {
        let payload = {
          tableName: "ms_vendors",
          v_is_active: "Y",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.Vendors = data.Records;
              this.VendorsCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      },
      getRawMaterials: function () {
        let payload = {
          vendor_id: this.purchasOrderDetails.v_id,
          cinema_id: this.purchasOrderDetails.cinema_id,
        };
        let loader = this.$loading.show();
        // this.RawMaterialsList = [];
        this.RawMaterialsList = Array.from({ length: 10 }, () => ({
          main_raw_material: "",
          rm_name: "",
          rm_id: "",
          po_quantity: "",
          poi_qty: "",
          poi_rate: "",
          poi_tax_in_percentage: this.defaultTaxPercent || "",
          poi_tax_amount: "",
          uom_unit: "",
          uom_id: "",
          po_total_amount: "",
          SelectedRawMaterial: null,
          uom_units: [],
          firstTimeSet: 0,
          isNew: false,
          showAll: false,
          selectedUOM: null,
          poi_remarks: "",
          charge_setting_id: null,
          charge_setting_name: null,
          selectedChargeSetting: "",
          taxes: [],
          charge_array: [],
        }));
        this.addVendor();
        this.purchasOrderDetails.po_total_amount = 0;
        PosFnbService.GetVendorRateDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.RawMaterials = data.Records;
              this.RawMaterialsCopy = data.Records;
              this.RawMaterials = this.RawMaterials.map((x) => {
                x["singleItemPrice"] =
                  parseFloat(x.vr_rate) / Number(x.vr_qty);
                x["singleTaxPrice"] =
                  parseFloat(x.vr_tax_amount) / Number(x.vr_qty);
                x["singleTotalPrice"] =
                  x["singleItemPrice"] + x["singleTaxPrice"];
                return x;
              });
              console.log("this.RawMaterials :", this.RawMaterials);
              // this.RawMaterials.map(x => {});
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError); //message
      },
      onSelectCinema: function (params, type) {
        if (type == "remove") {
          this.cinema_selected_new = [];
          this.selectedCinema = "";
          this.purchasOrderDetails.cinema_id = null;
        } else {
          this.cinema_selected_new = [params];
          console.log(this.cinema_selected_new, "this.cinema_selected_new");
          this.selectedCinema = params;
          this.purchasOrderDetails.cinema_id = params.cine_id;
          this.getChargeSettingName(params.cine_id);
        }
      },

      onSelectRawMaterial: function (params, index, rawkey) {
        console.log(params);

        let findIndexNew = this.RawMaterialsList.findIndex((x) => {
          return x.rm_id == String(params.rm_id);
        });
        console.log("findIndexNew 2", findIndexNew);
        if (findIndexNew < 0 || true) {
          this.RawMaterialsList[index].rm_name = params.rm_name;
          this.RawMaterialsList[index].rm_id = String(params.rm_id);
          this.RawMaterialsList[index].SelectedRawMaterial = params;
          this.RawMaterialsList[index].selectedUOM = {
            uom_id: params.uom_id,
            uom_short_form: params.uom_short_form,
            uom_unit: params.uom_unit,
          };
          console.log(
            " this.RawMaterialsList[index].selectedUOM",
            this.RawMaterialsList[index].selectedUOM
          );
          this.RawMaterialsList[index].uom_unit = params.uom_unit;
          this.RawMaterialsList[index].uom_id = params.uom_id;
          this.RawMaterialsList[index].poi_qty = "";
          this.RawMaterialsList[index].poi_rate = "";
          this.RawMaterialsList[index].poi_tax_in_percentage =
            this.defaultTaxPercent || "";

          console.log(
            "this.RawMaterialsList[index].uom_id jshdjkhsjkhd",
            this.RawMaterialsList[index].uom_id
          );
          console.log("params jshdjkhsjkhd", params);
          this.getRelatedUom(index, params.rm_id);
          // this.CalculateSelectedRawMaterial(
          //   this.RawMaterialsList[index]["poi_qty"],
          //   index
          // );
        } else {
          this.$toasted.show(` ${params.rm_name} already selected `);
        }
      },
      getRelatedUom: function (index, rm_id) {
        let cinema_id = this.purchasOrderDetails.cinema_id;
        PosFnbService.getUomFromRawMaterial({ rm_id, cinema_id: cinema_id })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.RawMaterialsList[index].uom_units = data.Records;
              this.listOfConversionRate = data.UnitMeasurement;
              if (data.RawMaterialPrice.length > 0) {
                let checkVendorExist = data.RawMaterialPrice.filter((z) => {
                  return (
                    String(z.vendor_id) == String(this.purchasOrderDetails.v_id)
                  );
                });
                this.selectedRawMaterialPrice = data.RawMaterialPrice;
                if (checkVendorExist.length > 0) {
                  if (
                    data.Records.length == 1 ||
                    checkVendorExist[0].uom_id ==
                      this.RawMaterialsList[index]["uom_id"]
                  ) {
                    console.log(this.RawMaterialsList[index], "poi_rate");
                    this.RawMaterialsList[index].poi_rate = parseFloat(
                      checkVendorExist[0].singleRate
                    ).toFixed(5);
                    this.RawMaterialsList[index].uom_id =
                      checkVendorExist[0].uom_id;
                    this.RawMaterialsList[index].uom_unit =
                      this.RawMaterialsList[index].SelectedRawMaterial[
                        "uom_unit"
                      ] || null;
                    this.RawMaterialsList[index].poi_tax_amount = parseFloat(
                      checkVendorExist[0].singleTax
                    ).toFixed(4);
                    this.RawMaterialsList[index].poi_tax_in_percentage =
                      +parseFloat(
                        (checkVendorExist[0].singleTax * 100) /
                          checkVendorExist[0].singleRate
                      ).toFixed(4);
                  }
                  console.log(
                    "this.RawMaterialsList[index] HEREbshjdh",
                    this.RawMaterialsList[index]
                  );
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(error);
          });
      },
      onSelectVendor: function (params, type) {
        if (type == "remove") {
          this.selectedVendor = "";
          this.purchasOrderDetails.v_id = null;
        } else {
          this.selectedVendor = params;
          this.purchasOrderDetails.v_id = params.v_id;
          this.getRawMaterials();
        }
      },

      onSelectQuantity: function (params, index) {
        this.RawMaterialsList[index]["poi_qty"] = params.toString();
        this.CalculateSelectedRawMaterial(
          this.RawMaterialsList[index]["poi_qty"],
          index
        );
      },
      calculateNetAmount: function (item, index = null) {
        console.log(item);

         const poi_qty = item.poi_qty;
          // if (poi_qty && poi_qty.length > 15) {
          //   item.poi_qty = parseFloat(poi_qty.slice(0, 15));
          //   this.purchaseOrderErrorDetails["hasError"] = true;
          //   this.purchaseOrderErrorDetails["errorMsg"] = "Invalid Qty Value";
          //   if(isNaN(String(index))) {
          //    this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          //   }
          // }
          if (!this.isValidNumberString(poi_qty, 6, 7)) {
            item.poi_qty = this.sanitizeTruncate(poi_qty, 6, 7);
            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = "Invalid Qty Value";
            if(isNaN(String(index))) {
             this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
            }
          }

         const poi_rate = item.poi_rate;
          if (!this.isValidNumberString(poi_rate)) {
            item.poi_rate = this.sanitizeTruncate(poi_rate);
            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = "Invalid Rate Value";
            if(isNaN(String(index))) {
             this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
            }
          }

          const poi_tax_in_percentage = item.poi_tax_in_percentage;
          if (!this.isValidNumberString(poi_tax_in_percentage, 3, 4)) {
            item.poi_tax_in_percentage = this.sanitizeTruncate(poi_tax_in_percentage, 3, 4);
            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = "Invalid Tax Value";
            if(isNaN(String(index))) {
             this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
            }
          }

        if (item.poi_rate && item.poi_qty) {
          item.poi_price = +parseFloat(item.poi_rate * item.poi_qty).toFixed(5);
        }

        if (
          item.poi_price &&
          (item.poi_tax_in_percentage || item.poi_tax_in_percentage == 0)
        ) {
          item.poi_tax_amount = +parseFloat(
            (item.poi_price * item.poi_tax_in_percentage) / 100
          ).toFixed(4);
        }

        if (
          item.poi_price &&
          (item.poi_tax_amount || item.poi_tax_amount == 0)
        ) {
          item.poi_total_amount = +parseFloat(
            item.poi_price + item.poi_tax_amount
          ).toFixed(4);
        }
        this.purchasOrderDetails.po_total_amount = 0;
        this.RawMaterialsList.map((x) => {
          if (x.poi_total_amount) {
            this.purchasOrderDetails.po_total_amount += parseFloat(
              x.poi_total_amount
            );
          }
        });

        item.poi_price = parseFloat(item.poi_price || 0).toFixed(5);
        item.poi_tax_amount = parseFloat(item.poi_tax_amount || 0).toFixed(4);
        item.poi_total_amount = parseFloat(item.poi_total_amount || 0).toFixed(
          4
        );
        this.purchasOrderDetails.po_total_amount = parseFloat(
          this.purchasOrderDetails.po_total_amount || 0
        ).toFixed(4);
      },
      CalculateSelectedRawMaterial: function (params, index) {
        if (this.RawMaterialsList[index]["isNew"]) {
          this.RawMaterialsList[index]["poi_total_amount"] = +parseFloat(
            parseFloat(this.RawMaterialsList[index]["poi_tax_amount"] || 0) +
              parseFloat(this.RawMaterialsList[index]["poi_price"] || 0)
          ).toFixed(4);
          this.purchasOrderDetails.po_total_amount = 0;
          this.RawMaterialsList.map((x) => {
            this.purchasOrderDetails.po_total_amount += parseFloat(
              x.poi_total_amount
            );
          });

          console.log("Quantity Cannot Be Calculated", this.RawMaterialsList);
          return false;
        }
        if (params && String(params).length > 0) {
          this.RawMaterialsList[index]["vendor_rate_id"] =
            this.RawMaterialsList[index].SelectedRawMaterial["vr_id"] || null;

          if (this.RawMaterialsList[index].firstTimeSet == 0) {
            this.RawMaterialsList[index]["uom_unit"] =
              this.RawMaterialsList[index].SelectedRawMaterial["uom_unit"] ||
              null;

            this.RawMaterialsList[index]["uom_id"] =
              this.RawMaterialsList[index].SelectedRawMaterial["uom_id"] ||
              null;
            this.RawMaterialsList[index].firstTimeSet = 1;
          }

          let fromUnit = this.listOfConversionRate.filter((x) => {
            return (
              x.conversion_from ==
              this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
            );
          });

          let toUnit = this.listOfConversionRate.filter((x) => {
            return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
          });

          if (fromUnit.length > 0 && toUnit.length > 0) {
            console.log(1);
            let from_kg =
              this.RawMaterialsList[index].SelectedRawMaterial["vr_qty"] *
              fromUnit[0].conversion_formula;
            let to_kg = Number(params) * toUnit[0].conversion_formula;
            let net_amount = parseFloat(
              (to_kg / from_kg) *
                this.RawMaterialsList[index].SelectedRawMaterial["vr_rate"]
            ).toFixed(4);
            let tax_amount = parseFloat(
              (to_kg / from_kg) *
                this.RawMaterialsList[index].SelectedRawMaterial[
                  "vr_tax_amount"
                ]
            ).toFixed(4);
            let poi_total_amount = parseFloat(net_amount + tax_amount).toFixed(
              4
            );
            this.RawMaterialsList[index]["poi_price"] = parseFloat(net_amount).toFixed(5);
            this.RawMaterialsList[index]["poi_tax_amount"] = tax_amount;
            this.RawMaterialsList[index]["poi_total_amount"] = poi_total_amount;
            this.RawMaterialsList[index]["poi_total_amount"] =
              Number(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleTotalPrice"
              ];
          } else {
            console.log(2);
            this.RawMaterialsList[index]["poi_price"] = parseFloat(
              Number(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleItemPrice"
              ]
            ).toFixed(5);

            this.RawMaterialsList[index]["poi_tax_amount"] =
              Number(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleTaxPrice"
              ];

            this.RawMaterialsList[index]["poi_total_amount"] =
              Number(params) *
              this.RawMaterialsList[index].SelectedRawMaterial[
                "singleTotalPrice"
              ];
          }

          console.log(fromUnit, toUnit);

          this.RawMaterialsList[index]["poi_is_active"] = true;

          this.purchasOrderDetails.po_total_amount = 0;
          this.RawMaterialsList.map((x) => {
            this.purchasOrderDetails.po_total_amount += parseFloat(
              x.poi_total_amount
            );
          });
        }
      },

      onSelectUom: function (params, index) {
        this.RawMaterialsList[index].uom_unit = params.uom_unit;
        this.RawMaterialsList[index].uom_id = params.uom_id;
        console.log("params.uom_id", params.uom_id);
        console.log(
          "this.RawMaterialsList[index]",
          this.RawMaterialsList[index]
        );
        let checkVendorExist = this.selectedRawMaterialPrice.filter((z) => {
          return String(z.vendor_id) == String(this.purchasOrderDetails.v_id);
        });
        let fromUnit = this.listOfConversionRate.filter((x) => {
          return (
            x.conversion_from ==
            this.RawMaterialsList[index].SelectedRawMaterial["uom_id"]
          );
        });

        let toUnit = this.listOfConversionRate.filter((x) => {
          return x.conversion_from == this.RawMaterialsList[index]["uom_id"];
        });

        console.log(fromUnit, toUnit, checkVendorExist);

        if (
          fromUnit.length > 0 &&
          toUnit.length > 0 &&
          checkVendorExist.length
        ) {
          console.log(1);
          let from_kg = 1 * fromUnit[0].conversion_formula;
          let to_kg = Number(1) * toUnit[0].conversion_formula;
          let net_amount = parseFloat(
            (to_kg / from_kg) * checkVendorExist[0]["singleRate"]
          ).toFixed(4);
          let tax_amount = parseFloat(
            (to_kg / from_kg) * checkVendorExist[0]["singleTax"]
          ).toFixed(4);
          console.log(tax_amount, net_amount);
          this.RawMaterialsList[index].poi_rate = +parseFloat(
            net_amount / 1
          ).toFixed(5);
          this.RawMaterialsList[index].poi_tax_amount = +parseFloat(
            tax_amount * (this.RawMaterialsList[index].poi_qty || 1)
          ).toFixed(4);
          this.RawMaterialsList[index].poi_price = parseFloat(
            net_amount * (this.RawMaterialsList[index].poi_qty || 1)
          ).toFixed(5);
          this.RawMaterialsList[index].poi_tax_in_percentage = +parseFloat(
            (tax_amount * 100) / net_amount
          ).toFixed(4);
          this.RawMaterialsList[index]["poi_total_amount"] =
            this.RawMaterialsList[index].poi_price +
            this.RawMaterialsList[index].poi_tax_amount;
          console.log(
            'this.RawMaterialsList[index]["poi_total_amount"]',
            this.RawMaterialsList[index]["poi_total_amount"]
          );
          console.log(
            'this.RawMaterialsList[index]["poi_price"]',
            this.RawMaterialsList[index]["poi_price"]
          );
          console.log(
            'this.RawMaterialsList[index]["poi_tax_amount"]',
            this.RawMaterialsList[index]["poi_tax_amount"]
          );
          console.log(
            'this.RawMaterialsList[index]["poi_tax_in_percentage"]',
            this.RawMaterialsList[index]["poi_tax_in_percentage"]
          );
          if (this.RawMaterialsList[index].poi_qty) {
            this.purchasOrderDetails.po_total_amount = 0;
            this.RawMaterialsList.map((x) => {
              if (x.poi_total_amount) {
                this.purchasOrderDetails.po_total_amount += parseFloat(
                  x.poi_total_amount
                );
              }
            });
          }

          //   let poi_total_amount = parseFloat(net_amount + tax_amount).toFixed(4);
          //   this.RawMaterialsList[index]["poi_price"] = net_amount;
          //   this.RawMaterialsList[index]["poi_tax_amount"] = tax_amount;
          //   this.RawMaterialsList[index]["poi_total_amount"] = poi_total_amount;
          //   this.RawMaterialsList[index]["poi_total_amount"] =
          //     parseInt(params) *
          //     this.RawMaterialsList[index].SelectedRawMaterial["singleTotalPrice"];
          // }
          // this.CalculateSelectedRawMaterial(
          //   this.RawMaterialsList[index].poi_qty,
          //   index
          // );
        }
      },
      addVendor: function () {
        this.RawMaterialsList.push({
          rm_name: "",
          rm_id: "",
          poi_price: "",
          poi_tax_amount: "",
          poi_tax_in_percentage: this.defaultTaxPercent || "",
          poi_rate: "",
          poi_total_amount: "",
          po_quantity: "",
          poi_qty: "",
          uom_unit: "",
          uom_id: "",
          po_total_amount: "",
          SelectedRawMaterial: null,
          uom_units: [],
          firstTimeSet: 0,
          isNew: false,
          showAll: false,
          selectedUOM: "",
          poi_remarks: "",
        });
      },
      removeVendor: function (index) {
        this.RawMaterialsList.splice(index, 1);
      },
      validatePurchaseOrderArray() {
        let errorCount = 0;
        let errorMsg = ``;
        let errIndex = null;
        this.purchaseOrderErrorDetails["hasError"] = false;
        this.purchaseOrderErrorDetails["errorMsg"] = "";
        this.purchaseOrderErrorDetails["errorIndexArray"] = [];
        this.RawMaterialsList.map((row, index) => {
          if (
            (row.rm_id || row.uom_id || row.poi_qty || row.poi_rate) &&
            (!row.rm_id || !row.uom_id || !row.poi_qty || !row.poi_rate)
          ) {
            errorCount++;
            errorMsg = `Incomplete Row. Please Fill the Details Properly`;
            errIndex = index;

            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = errorMsg;
            this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          } else if (row.poi_qty < 0 || row.poi_rate < 0) {
            errorCount++;
            errorMsg = `Invalid Values. Negative Values are not allowed.`;
            errIndex = index;

            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = errorMsg;
            this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          } else if(row.poi_price && !this.isValidNumberString(row.poi_price, 13, 7)) {
            errorCount++;
            errorMsg = "Gross Total it too big. Kindly try with less value.";
            errIndex = index;
            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = errorMsg;
            this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          } else if(row.poi_remarks && row.poi_remarks.length > 200) {
            errorCount++;
            errorMsg = "Remark cannot be more than 200 characters.";
            errIndex = index;
            this.purchaseOrderErrorDetails["hasError"] = true;
            this.purchaseOrderErrorDetails["errorMsg"] = errorMsg;
            this.purchaseOrderErrorDetails["errorIndexArray"].push(index);
          }
        });
        if (errorCount > 0) {
          console.log(
            "this.purchaseOrderErrorDetails",
            this.purchaseOrderErrorDetails
          );
          this.$toasted.show(errorMsg);
          return false;
        } else {
          return true;
        }
      },
      onFinalSubmit: function () {
        let checkValid = this.validatePurchaseOrderArray();
        let finalPurchaseArray = this.RawMaterialsList.filter(
          (x) =>
            x.rm_id &&
            x.uom_id &&
            !isNaN(String(x.poi_rate)) &&
            !isNaN(String(x.poi_qty))
        );
        console.log("this.RawMaterialsList", this.RawMaterialsList);

        if(finalPurchaseArray.length == 0) {
          this.$toasted.show("Purchase order must have atleast one Raw material.")
          return false;
        }

        finalPurchaseArray.forEach((_rm) => {
          _rm["uom_id"] = _rm["selectedUOM"]["uom_id"];
          _rm["uom_unit"] = _rm["selectedUOM"]["uom_unit"];
        });

        this.submitted = true;

        this.$validator.validate().then((valid) => {
          if (valid && checkValid) {
            let loader = this.$loading.show();

            this.btenable = true;
            let payload = {
              ...this.purchasOrderDetails,
              vendorList: finalPurchaseArray,
            };
            console.log("this.RawMaterialsList :", this.RawMaterialsList);
            PosFnbService.AddPurchaseOrder(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.$router.push({
                    path: "purchase-order",
                  });
                } else {
                  this.$toasted.show(data.message);
                }
                loader.hide();
              })
              .catch(this._CatchError); //message
          }
        });
      },
    },
  };
</script>

<style scoped>
  .sectionName {
    padding: 5px 0px;
    color: #4a87e1;
  }

  .sectionName .fs-17 {
    font-size: 17px !important;
  }

  .text-small-instruction {
    font-weight: 400;
  }

  .text-red {
    color: red;
  }

  .percentText {
    color: black;
    font-size: 15px;
    font-weight: bold;
    position: relative;
    padding-inline: 8px;
  }

  .qtyInput {
    border-radius: 5px;
    border: 1px solid #777575;
    width: 80%;
    height: 30px;
  }

  .disable-field {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .bor {
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }

  .back {
    background-color: #f5f5f5;
  }

  .inner-vendor-rate {
    background-color: #fff;
    border: 1px solid #b1b4b8;
    border-radius: 10px;
  }

  .po_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
  }

  .po_input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
  }

  .po_input input::placeholder,
  .po_wrapper .multiselect__placeholder {
    font-size: 10px !important;
    font-style: italic !important;
  }

  .input_text-center input {
    text-align: center;
  }

  .input_text-right input {
    text-align: right;
  }

  .po_wrapper .multiselect__placeholder {
    font-weight: unset !important;
    line-height: 25px;
  }

  .purchase_input::placeholder {
    font-size: 10px !important;
    font-style: italic !important;
  }

  .noItemsClass {
    text-align: center;
    width: 100%;
    margin: 16px auto;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
  }

  .taxPopOver {
    zoom: 0.8;
    min-width: 200px;
  }

  .errRow {
    border: 2px solid red;
  }

  .borderNone {
    border: none !important;
  }

  .complete-tick {
    width: 120px;
    height: 120px;
    display: inline-block;
    background-size: contain;
  }

  .errorLine {
    color: red;
    border: 1px solid red;
  }

  .redLine {
    color: red !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PurchaseOrderComponents/addPurchaseOrderv2.vue